(() => {
  if (window.sbcCartLoaded) return;
  window.sbcCartLoaded = true;
  let busy = false;
  const drawer = () => document.querySelector('cart-drawer.sbc-drawer');
  const variant = root => {
    const input = root?.querySelector('[data-cart-upsell-variant]');
    if (!input || input.disabled || (input.tagName === 'SELECT' && (!input.selectedOptions[0] || input.selectedOptions[0].disabled))) return null;
    return /^\d+$/.test(String(input.value)) ? String(input.value) : null;
  };
  function enhance() {
    const cart = drawer();
    if (typeof cart?.renderContents !== 'function') return;
    cart.querySelectorAll('[data-cart-upsell-item]').forEach(root => {
      const controls = root.querySelector('[data-cart-upsell-controls]');
      if (!controls) return;
      controls.hidden = false;
      root.querySelector('.product-card__link').hidden = true;
      root.querySelector('[data-cart-upsell-add]').disabled = !variant(root);
    });
  }
  function validSections(cart, sections) {
    return cart.getSectionsToRender().every(section => typeof sections?.[section.id] === 'string' &&
      new DOMParser().parseFromString(sections[section.id], 'text/html').querySelector(section.selector || '.shopify-section'));
  }
  async function readSections(cart) {
    const url = new URL(window.routes.cart_url, location.origin);
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.searchParams.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(cart.dataset.sbcError);
    const sections = await response.json();
    if (!validSections(cart, sections)) throw new Error(cart.dataset.sbcError);
    return sections;
  }
  function render(cart, sections) {
    cart.renderContents({ sections }, { open: false });
    enhance();
  }
  function focusInside(cart, target) {
    if (!cart.classList.contains('active')) return;
    const surface = cart.querySelector('.drawer__inner');
    if (typeof trapFocus === 'function') trapFocus(surface, target || surface);
    else target?.focus();
  }
  async function add(button) {
    const cart = drawer(), root = button.closest('[data-cart-upsell-item]');
    const id = variant(root);
    if (!cart || busy || button.disabled || !id) return;
    const pendingQuantity = cart.querySelector('.cart__items--disabled') || Array.from(cart.querySelectorAll('.quantity__input')).some(input => input.value !== input.getAttribute('value'));
    if (pendingQuantity) { root.querySelector('[data-product-status]').textContent = cart.dataset.sbcLoading; return; }
    busy = true;
    const productId = root.dataset.cartUpsellItem;
    const savedScroll = cart.querySelector('cart-drawer-items').scrollTop;
    const errorRegion = root.querySelector('[data-product-error]');
    errorRegion.hidden = true; errorRegion.textContent = '';
    root.setAttribute('aria-busy', 'true');
    root.querySelector('[data-product-status]').textContent = cart.dataset.sbcLoading;
    const controls = Array.from(cart.querySelectorAll('button:not(.drawer__close):not([data-sbc-close]), input, select, textarea')).map(control => [control, control.disabled]);
    controls.forEach(([control]) => { control.disabled = true; });
    const data = new FormData();
    data.set('id', id); data.set('quantity', '1');
    data.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
    data.set('sections_url', location.pathname + location.search);
    try {
      const response = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : cart.dataset.sbcError);
      let sections = result.sections;
      if (!validSections(cart, sections)) {
        try { sections = await readSections(cart); } catch { location.assign(window.routes.cart_url); return; }
      }
      render(cart, sections);
      cart.querySelector('[data-sbc-status]').textContent = cart.dataset.sbcAdded;
      const line = Array.from(cart.querySelectorAll('[data-sbc-product]')).find(node => node.dataset.sbcProduct === productId);
      focusInside(cart, line?.querySelector('.cart-item__name'));
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sbc-cart-upsell', cartData: result, productVariantId: id });
    } catch (error) {
      try { render(cart, await readSections(cart)); } catch { /* Keep the current controls and visible error for retry. */ }
      const current = Array.from(cart.querySelectorAll('[data-cart-upsell-item]')).find(node => node.dataset.cartUpsellItem === productId);
      const input = current?.querySelector('[data-cart-upsell-variant]');
      if (input?.tagName === 'SELECT' && Array.from(input.options).some(option => option.value === id && !option.disabled)) input.value = id;
      const region = current?.querySelector('[data-product-error]') || cart.querySelector('#CartDrawer-CartErrors');
      region.textContent = error.message || cart.dataset.sbcError; region.hidden = false;
      if (current) current.querySelector('[data-product-status]').textContent = '';
      cart.querySelector('cart-drawer-items').scrollTop = savedScroll;
      focusInside(cart, input?.tagName === 'SELECT' ? input : current?.querySelector('.product-card__title a'));
    } finally {
      busy = false;
      root.removeAttribute('aria-busy');
      root.querySelector('[data-product-status]').textContent = '';
      controls.forEach(([control, disabled]) => { if (control.isConnected) control.disabled = disabled; });
      enhance();
    }
  }
  document.addEventListener('click', event => {
    if (busy && event.target.closest('cart-drawer.sbc-drawer cart-remove-button')) { event.preventDefault(); event.stopPropagation(); return; }
    const button = event.target.closest('.sbc-drawer [data-cart-upsell-add]');
    if (button) { event.preventDefault(); add(button); }
  }, true);
  document.addEventListener('change', event => {
    const input = event.target.closest('.sbc-drawer [data-cart-upsell-variant]');
    if (!input) return;
    event.stopPropagation();
    if (busy) return;
    const root = input.closest('[data-cart-upsell-item]');
    root.querySelector('[data-product-error]').hidden = true;
    enhance();
  }, true);
  customElements.whenDefined('cart-drawer').then(() => {
    enhance();
    const cart = drawer();
    if (cart) new MutationObserver(enhance).observe(cart, { childList: true, subtree: true });
  });
})();
